const ADMIN_HOSTS = new Set(['admin.traderhub24.com', 'admin.localhost'])

export function isAdminApp(): boolean {
  if (typeof window === 'undefined') return false
  if (import.meta.env.VITE_ADMIN_APP === 'true') return true
  const host = window.location.hostname.toLowerCase()
  return ADMIN_HOSTS.has(host)
}

export function getAdminAppOrigin(): string {
  if (typeof window !== 'undefined' && isAdminApp()) {
    return window.location.origin
  }
  const configured = import.meta.env.VITE_ADMIN_APP_URL
  if (configured) return configured.replace(/\/$/, '')
  return 'https://admin.traderhub24.com'
}

export function getAdminAppUrl(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${getAdminAppOrigin()}${normalized}`
}

export function getMainAppOrigin(): string {
  const configured = import.meta.env.VITE_SITE_URL
  if (configured) return configured.replace(/\/$/, '')
  if (typeof window !== 'undefined' && !isAdminApp()) {
    return window.location.origin
  }
  return 'https://www.traderhub24.com'
}

export function getMainAppUrl(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${getMainAppOrigin()}${normalized}`
}
